import useSWR from 'swr';
import { Device, WebsiteMenu } from '@tempi/core-renderer';
import { PbService } from '../service';
import { LayoutConfig } from '../types';
import { useTenantConfig } from 'hooks';

type UsePbLayoutReturn = {
  layoutConfig?: LayoutConfig;
  menu?: WebsiteMenu[];
  websiteId?: number;
};
type UseLayout = (params: {
  device: Device;
  defaultValue?: UsePbLayoutReturn;
}) => UsePbLayoutReturn & {
  loading?: boolean;
  error?: string;
};

export const usePbLayout: UseLayout = ({ device, defaultValue }) => {
  const { epicEcom480, tempiWebsiteDomain } = useTenantConfig();
  const { data, error, isValidating } = useSWR(
    [device],
    async (device) => {
      const builder = new PbService(
        epicEcom480
          ? tempiWebsiteDomain || ''
          : window?.location?.hostname || '',
        window?.location?.hostname,
        epicEcom480 || false,
      );
      const { layoutConfig, menu, websiteId }: UsePbLayoutReturn =
        await builder.getLayoutPage(device);

      return { layoutConfig, menu, websiteId };
    },
    {
      fallbackData: defaultValue,
      revalidateOnFocus: false,
    },
  );

  return {
    ...data,
    error,
    loading: isValidating,
  };
};
